<template>
  <w-modal
    v-model="show"
    submit-button="Stwórz paczkę"
    close-button="Anuluj"
    :title="$schema.$title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="col-12 mb-5">
        <school-picker-secretary :school-model="$schema" :with-parents="true" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import SchoolPickerSecretary from '@/components/forms/SchoolPickerSecretary';
import { Errors } from '@/enums/errors.enum';
import { formMixin } from '@/mixins/form';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/createPack.schema';

// @vuese
// Modal generowania CSV
// @group modals
export default {
  components: { SchoolPickerSecretary },
  mixins: [formMixin, modalMixin, notificationsMixin],
  schema,
  data() {
    return { model: {} };
  },
  methods: {
    // @vuese
    // Wysyła event zapisu paczki dokumentów
    save() {
      const nodeId = this.$schema.nodeId.$model;
      if (!nodeId) {
        return this.notifyError(Errors.SCHOOL_NOT_SELECTED);
      }
      this.$emit('save', nodeId);
    }
  }
};
</script>
